<div class="app-sidebar sidebar-shadow bg-midnight-bloom sidebar-text-light">
  <div class="scrollbar-sidebar">
    <div class="app-sidebar__inner">
      <div id="accordian">
        <ul class="vertical-nav-menu">
          <li class="app-sidebar__heading">Menu</li>
          <li>
            <a
              href="javascript:void(0);"
              (click)="goToPage('/dashboard')"
              [ngClass]="{ 'mm-active': isCurrentRoute('/dashboard') }"
            >
              <i class="metismenu-icon pe-7s-rocket"></i> <span>Dashboard</span>
            </a>
          </li>

          <li class="has-child">
            <a
              href="javascript:void(0);"
              (click)="toggleItem('masters')"
              [ngClass]="{ 'has-child': true, active: isActive('masters') }"
            >
              <i class="metismenu-icon pe-7s-note2"></i> <span>Masters</span>
              <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
            </a>
            <ul *ngIf="isActive('masters')">
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/masters/document-type-master')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/masters/document-type-master') }"
                >
                  <i class="metismenu-icon"></i> <span>Document Type Master</span>
                </a>
              </li> 
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/masters/item-master')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/masters/item-master') }"
                >
                  <i class="metismenu-icon"></i> <span>Item Master</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/masters/generic-master')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/masters/generic-master') }"
                >
                  <i class="metismenu-icon"></i> <span>Custom Masters</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/masters/user-master')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/masters/user-master') }"
                >
                  <i class="metismenu-icon"></i> <span>WA User Master</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/masters/pending-registrations')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/masters/pending-registrations') }"
                >
                  <i class="metismenu-icon"></i> <span>Pending Registrations</span>
                </a>
              </li>
            </ul>
          </li>

          <li class="has-child">
            <a
              href="javascript:void(0);"
              (click)="toggleItem('campaign')"
              [ngClass]="{ 'has-child': true, active: isActive('campaign') }"
            >
              <i class="metismenu-icon pe-7s-speaker"></i> <span>Campaign</span>
              <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
            </a>
            <ul *ngIf="isActive('campaign')">
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/campaign/start')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/campaign/start') }"
                  style="font-weight:600"
                >
                  <i class="metismenu-icon pe-7s-rocket"></i> <span>Start Campaign</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/campaign/pending-approvals')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/campaign/pending-approvals') }"
                >
                  <i class="metismenu-icon pe-7s-clock"></i> <span>Pending Approvals</span>
                </a>
              </li>
              <!-- <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/campaign/templates')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/campaign/templates') }"
                >
                  <i class="metismenu-icon"></i> <span>Template Creation</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/campaign')"
                  [ngClass]="{ 'mm-active': currentUrl === '/campaign' }"
                >
                  <i class="metismenu-icon"></i> <span>Campaign Creation</span>
                </a>
              </li>
              
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/campaign/trigger')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/campaign/trigger') }"
                >
                  <i class="metismenu-icon"></i> <span>Trigger Campaign</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/campaign/flows')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/campaign/flows') }"
                >
                  <i class="metismenu-icon pe-7s-plugin"></i> <span>WhatsApp Flows</span>
                </a>
              </li> -->
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/campaign/insights')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/campaign/insights') }"
                >
                  <i class="metismenu-icon pe-7s-graph1"></i> <span>Campaign Insights</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/campaign/recipients')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/campaign/recipients') }"
                >
                  <i class="metismenu-icon"></i> <span>Recipients Group</span>
                </a>
              </li>
            </ul>
          </li>

          <li class="has-child">
            <a
              href="javascript:void(0);"
              (click)="toggleItem('operations')"
              [ngClass]="{ 'has-child': true, active: isActive('operations') }"
            >
              <i class="metismenu-icon pe-7s-upload"></i> <span>Operations</span>
              <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
            </a>
            <ul *ngIf="isActive('operations')">
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/operations/upload-documents')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/operations/upload-documents') }"
                >
                  <i class="metismenu-icon"></i> <span>Upload Documents</span>
                </a>
              </li>
            </ul>
          </li>

          <li class="has-child">
            <a
              href="javascript:void(0);"
              (click)="toggleItem('admin')"
              [ngClass]="{ 'has-child': true, active: isActive('admin') }"
            >
              <i class="metismenu-icon pe-7s-config"></i> <span>Admin Control</span>
              <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
            </a>
            <ul *ngIf="isActive('admin')">
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/admin-control/upload-history')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/admin-control/upload-history') }"
                >
                  <i class="metismenu-icon"></i> <span>Show Upload History</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/admin-control/system-settings')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/admin-control/system-settings') }"
                >
                  <i class="metismenu-icon"></i> <span>System Settings</span>
                </a>
              </li>
              <!-- <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/admin-control/client-onboarding')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/admin-control/client-onboarding') }"
                >
                  <i class="metismenu-icon"></i> <span>Client Onboarding</span>
                </a>
              </li> -->
              <li>
                <a
                  href="javascript:void(0);"
                  (click)="goToPage('/admin-control/portal-users')"
                  [ngClass]="{ 'mm-active': isCurrentRoute('/admin-control/portal-users') }"
                >
                  <i class="metismenu-icon"></i> <span>Admin User Master</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
